import { render, staticRenderFns } from "./AddAmaDialog.vue?vue&type=template&id=81434dd2"
import script from "./AddAmaDialog.vue?vue&type=script&lang=js"
export * from "./AddAmaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports